










import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class vscCheckbox extends Vue {
    @Prop() private value!: string;
    @Prop() label!: string;
    @Prop() suffix!: string | object;
    @Prop({ default: "" }) size!: string;
    @Prop({ default: true }) margin!: boolean;

    get inputValue() {
        return this.value;
    }

    set inputValue(input) {
        this.$emit("input", input);
    }

    get colSize() {
        if (this.size === "xl") return "col-lg-12";
        return "col-lg-8";
    }

    get rowClasses() {
        return `${this.margin ? "" : "mb-0"}`;
    }
}
